module.exports = __webpack_public_path__ + "img/patient.e573e3fc.svg";